import { render, staticRenderFns } from "./VoiceSetting.vue?vue&type=template&id=5cd5f5f4&scoped=true&"
import script from "./VoiceSetting.vue?vue&type=script&lang=js&"
export * from "./VoiceSetting.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSetting.vue?vue&type=style&index=0&id=5cd5f5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5f5f4",
  null
  
)

export default component.exports